export const DEFAULT_ADMIN_TABLE_HEIGHT = 'calc(100vh - 308px)'
export const DEFAULT_ADMIN_TABLE_WITH_PAGINATION_HEIGHT = 'calc(100vh - 352px)'
export const DEFAULT_PAGE_SIZE = 20
export const DEFAULT_PAGE_SIZE_OPTIONS = [20, 30, 50, 100]
